import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=612465fe&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"
import style0 from "./Chat.vue?vue&type=style&index=0&id=612465fe&prod&lang=scss&scoped=true&"
import style1 from "./Chat.vue?vue&type=style&index=1&id=612465fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612465fe",
  null
  
)

export default component.exports